import { NgModule, Component } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { EligibilityListComponent } from './eligibility-list/eligibility-list.component';
import { EligibilityCreateComponent } from './eligibility-create/eligibility-create.component';

const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list-page',
        component: EligibilityListComponent,
        data: {
          title: "List Page",
          breadcrumb: "List Page"
        }
      },
      {
        path: 'create-page',
        component: EligibilityCreateComponent,
        data: {
          title: "Create Page",
          breadcrumb: "Create Page"
        }
      },
      {
        path: 'eligibility-create/:id',
        component: EligibilityCreateComponent,
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class EligibilityRoutingModule { }
